export enum ComposerType {
    CONVERSATION_MESSAGE = 1,
    EMPTY = 2
}